import { Box, Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

import { Avatar } from "../../Avatar";
import { AvatarWrapper, getAvatarBorderLevel } from "../../../Utilities/User";
import { ReasonIcon } from "../../ReasonIcon";
import { GameLogos } from "../../Icons";
import { ESupportedGames } from "MVVM/@types";

const gameStringToEnum: Record<string, ESupportedGames> = {
  CS2: ESupportedGames.CS2,
  CS_GO: ESupportedGames.CSGO,
  DOTA2: ESupportedGames.DOTA2,
  LOL: ESupportedGames.LOL,
  FORTNITE: ESupportedGames.FORTNITE,
  OW2: ESupportedGames.OW2,
  VALORANT: ESupportedGames.VALORANT,
};

interface IDropdownProps {
  avatar: string;
  callback: (arg0: string) => void;
  username: string;
  reason?: string;
  userGroup?: {
    type: string;
  };
  rank?: number;
  isSelected?: boolean;
  steam?: {
    steamid?: string;
    personaname?: string;
  };
  isProPlayer?: boolean;
  game?: string;
}

const DropdownItem = ({
  avatar,
  callback,
  username,
  reason,
  userGroup,
  rank,
  isSelected = false,
  steam,
  isProPlayer,
  game,
}: IDropdownProps) => {
  const avatarBorderLevel = getAvatarBorderLevel({ userGroup, rank });

  const displayName =
    (username !== "User" ? username : steam?.personaname) ?? "User";

  const gameEnum = game ? gameStringToEnum[game] : undefined;

  return (
    <Item
      onClick={() => callback(displayName)}
      isSelected={isSelected}
      data-dropdown-item
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" style={{ gap: 10 }}>
          <AvatarWrapper size="nav" borderLevel={avatarBorderLevel}>
            <AvatarOverride>
              <Avatar
                image={avatar}
                size="nav"
                profileCardUsername={username}
              />
            </AvatarOverride>
          </AvatarWrapper>
          <Box>
            <Text
              className="display-name"
              color="ice"
              fontSize={14}
              fontWeight={500}
            >
              {displayName}
            </Text>
            {isProPlayer && (
              <Flex alignItems="center" style={{ gap: 4, marginTop: 2 }}>
                {gameEnum !== undefined && (
                  <GameLogos
                    type={gameEnum}
                    size={14}
                    styles={{ marginRight: 0 }}
                  />
                )}
                <ProBadge>PRO</ProBadge>
              </Flex>
            )}
          </Box>
        </Flex>
        {reason && <ReasonIcon reason={reason} />}
      </Flex>
    </Item>
  );
};

const AvatarOverride = styled.div`
  & > * {
    background-color: transparent !important;
    border: 1px solid ${({ theme }) => theme.colors.navy50};
  }
`;

const ProBadge = styled(Text)`
  background-color: ${({ theme }) => theme.colors.proPlayer};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1;
  padding: 3px 6px;
  white-space: nowrap;
`;

const Item = styled(Box)<{ isSelected: boolean }>`
  border-radius: 12px;
  cursor: pointer;
  padding: 10px 16px;
  transition: background-color 0.2s;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.navy100 : "transparent"};

  &:hover {
    background-color: ${({ theme }) => theme.colors.navy100};
  }
`;

const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.envy};
  font-size: 16px;
  opacity: 0.8;
  display: flex;
  align-items: center;
`;

export { DropdownItem };
